{
  "accessPage": {
    "list": {
      "title": "List of rules",
      "empty": "List of rules is empty",
      "newElement": "New rule"
    },
    "item": {
      "empty": "Select a rule or create a new one"
    }
  },
  "ruleItem": {
    "title": "Rule",
    "label": "Label",
    "name": "Name",
    "action": "Action",
    "accessRight": "Access",
    "active": "Active",
    "expand": "Expandable",
    "expandTooltip": "When adding a new elem, the rule will be supplemented",
    "tab": {
      "cit": "CIT",
      "healthIndicators": "Health indicators",
      "user": {
        "label": "User",
        "anyUser": "Any user",
        "noUser": "No user",
        "login": "Login"
      },
      "dashboards": "Dashboards",
      "navigation": "Features"
    },
    "addTQL": "Add TQL"
  },
  "table": {
    "name": "Name",
    "read": "Read",
    "edit": "Edit"
  },
  "ruleCitDialog": {
    "title": "Filter"
  },
  "actionFilterDialog": {
    "title": "Action filter"
  }
}